// @flow
import visa from '../../assets/img/cardBrands/visa.png';
import mastercard from '../../assets/img/cardBrands/mastercard.png';
import amex from '../../assets/img/cardBrands/american_express.png';
import diners from '../../assets/img/cardBrands/diners_club.png';
import discover from '../../assets/img/cardBrands/discover.png';
import jcb from '../../assets/img/cardBrands/jcb.png';
import unionpay from '../../assets/img/cardBrands/china_union.png';

export const formatCardNumber = (val: string) =>
  val === '**** None' ? '**** ????' : val.replace(/([\d*]{4})/g, '$1 ');

export const getCardBrandIcon = (brand: string) => {
  switch (brand) {
    case 'amex':
      return amex;
    case 'visa':
      return visa;
    case 'mastercard':
      return mastercard;
    case 'diners':
      return diners;
    case 'discover':
      return discover;
    case 'jcb':
      return jcb;
    case 'unionpay':
      return unionpay;
    default:
      return null;
  }
};
